import { render, staticRenderFns } from "./ApDocumentDetail.vue?vue&type=template&id=5c58d8a8&scoped=true"
import script from "./ApDocumentDetail.vue?vue&type=script&lang=js"
export * from "./ApDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./ApDocumentDetail.vue?vue&type=style&index=0&id=5c58d8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58d8a8",
  null
  
)

export default component.exports